import React from 'react';

interface IProps {
	children: React.ReactNode;
}

export const FormRow: React.FC<IProps> = ({ children }) => (
	<div className="flex items-start gap-8 *:min-w-0 *:flex-1">{children}</div>
);
